import { Defect } from '../../models/defect.model';
import { DefectRef } from '../../models/defect-ref.model';
import { ResultStatus, RunnerCase, StepResultKind } from '../../models/test-run.model';

const CAPTURABLE_KINDS: ReadonlySet<StepResultKind> = new Set(['STEP', 'CHECK']);
const CAPTURABLE_STATUSES: ReadonlySet<ResultStatus> = new Set(['FAILED', 'BLOCKED']);

/** Dieselbe Regel wie im Backend (`DefectService`), sonst endet der Knopf in einem 409. */
export function canCaptureDefect(kind: StepResultKind, status: ResultStatus): boolean {
  return CAPTURABLE_KINDS.has(kind) && CAPTURABLE_STATUSES.has(status);
}

export function withDefect(defects: DefectRef[] | undefined, defect: Defect): DefectRef[] {
  return [...(defects ?? []), { id: defect.id, key: defect.key, blocking: defect.blocking, status: defect.status }];
}

export interface DefectFoundInLabel {
  rootKey: string | null;
  rootTitle: string | null;
  runKey: string | null;
}

export function moduleFoundIn(runnerCase: RunnerCase | null, runKey: string | null): DefectFoundInLabel | null {
  if (runnerCase?.rootKind !== 'MODULE') return null;
  return { rootKey: runnerCase.key, rootTitle: runnerCase.title, runKey };
}
